import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const TextCorrectionService = {
    correction: async (model, timeout) => axios.post(API_URL + "/ai/text-correction", model, timeout).then(({data}) => data).catch((err) => { throw err }),
};
export default TextCorrectionService;